<template>
  <div>
    <b-card
      title="Gaji Karyawan Belum Dibayar"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Entries</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <!-- <b-button
              variant="primary"
              @click="addGajiKaryawanSidebar = true"
            >
              + Tambah Data Gaji Karyawan
            </b-button> -->
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refInvoiceListTable"
        :items="rows"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="searchQuery"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
      >

        <!-- Column: Id -->
        <template #cell(id)="data">
          <span class="text-primary font-weight-bolder">#{{ data.value }}</span>
        </template>

        <!-- Column: Jumlah -->
        <template #cell(nominal_gaji)="data">
          <span class="text-warning">{{ data.value | formatRupiah }}</span>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            variant="light-danger"
          >
            {{ data.value === 'belum' ? 'Belum Dibayar' : 'Belum Dibayar' }}
          </b-badge>
        </template>

        <template #cell(action)="data">

          <div class="text-nowrap">
            <b-button-group>
              <b-button
                :id="`GajiKaryawan-row-${data.item.id}-edit-icon`"
                size="sm"
                variant="warning"
                @click="bayarGajiKaryawan(data.item, true)"
              >
                Bayarkan
              </b-button>
              <b-tooltip
                title="Edit"
                class="cursor-pointer"
                :target="`GajiKaryawan-row-${data.item.id}-edit-icon`"
              />

              <!-- <b-button
                :id="`GajiKaryawan-row-${data.item.id}-hapus-icon`"
                size="sm"
                variant="danger"
                @click="removeData(data.item.id)"
              >
                Hapus
              </b-button>
              <b-tooltip
                title="Hapus"
                :target="`GajiKaryawan-row-${data.item.id}-hapus-icon`"
              /> -->
            </b-button-group>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
          <!-- <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span> -->
          <!-- <span class="text-muted">Showing entries</span> -->
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalGajiKaryawan"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <b-card
      title="Riwayat Gaji Karyawan"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Entries</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQueryLunas"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refInvoiceListTable"
        :items="rowsLunas"
        responsive
        :fields="columnsLunas"
        primary-key="id"
        :sort-by.sync="sortBy"
        :per-page="perPage"
        :current-page="currentPageLunas"
        :filter="searchQueryLunas"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
      >

        <!-- Column: Id -->
        <template #cell(id)="data">
          <span class="text-primary font-weight-bolder">#{{ data.index + 1 }}</span>
        </template>

        <!-- Column: Jumlah -->
        <template #cell(nominal_gaji)="data">
          <span class="text-warning">{{ data.value | formatRupiah }}</span>
        </template>

        <!-- Column: Nama Gaji -->
        <template #cell(nama_gaji)="data">
          <span class="text-capitalize">{{ data.value }}</span>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="">
          <b-badge
            variant="light-success"
          >
            Sudah Dibayar
          </b-badge>
        </template>

        <template #cell(action)="data">

          <div class="text-nowrap">
            <b-button-group>
              <b-button
                :id="`GajiKaryawan-row-${data.item.id}-bayar-icon`"
                size="sm"
                variant="info"
                @click="detailGajiKaryawan(data.item)"
              >
                Detail
              </b-button>

              <!-- <b-button
                :id="`GajiKaryawan-row-${data.item.id}-hapus-icon`"
                size="sm"
                variant="danger"
                @click="removeData(data.item.id)"
              >
                Hapus
              </b-button>
              <b-tooltip
                title="Hapus"
                :target="`GajiKaryawan-row-${data.item.id}-hapus-icon`"
              /> -->
            </b-button-group>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
          <!-- <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span> -->
          <!-- <span class="text-muted">Showing entries</span> -->
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPageLunas"
              :total-rows="totalGajiKaryawanLunas"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

    <b-modal
      id="modal-1"
      v-model="modalDetail"
      :title="`Gaji Karyawan ${dataDetailGajiKaryawan.nama ? dataDetailGajiKaryawan.nama : ''}`"
      centered
      ok-only
      ok-title="Close"
    >
      <b-row>
        <b-col
          cols="12"
          class="d-flex"
        >
          <label
            class="mr-1"
          >Nama Karyawan: </label>
          <h6>{{ dataDetailGajiKaryawan.karyawan.nama }}</h6>
        </b-col>
        <b-col
          cols="12"
          class="d-flex"
        >
          <label
            class="mr-1"
          >Posisi Karyawan: </label>
          <h6>{{ dataDetailGajiKaryawan.karyawan.posisi }}</h6>
        </b-col>
        <b-col
          cols="12"
          class="d-flex"
        >
          <label
            class="mr-1"
          >Nama Gaji: </label>
          <h6>{{ dataDetailGajiKaryawan.nama_gaji }}</h6>
        </b-col>
        <b-col
          cols="12"
          class="d-flex"
        >
          <label
            class="mr-1"
          >Jumlah: </label>
          <h6>{{ dataDetailGajiKaryawan.nominal_gaji }}</h6>
        </b-col>
        <b-col
          cols="12"
          class="d-flex"
        >
          <label
            class="mr-1"
          >Tanggal Pembayaran: </label>
          <h6>{{ dataDetailGajiKaryawan.keuangan.tanggal ? dataDetailGajiKaryawan.keuangan.tanggal : '' }}</h6>
        </b-col>
        <b-col
          v-if="dataDetailGajiKaryawan.foto_nota"
          cols="12"
          class="d-flex"
        >
          <label
            class="mr-1"
          >Foto Nota: </label>
          <b-img
            :src="dataDetailGajiKaryawan.foto_nota"
            height="125"
            alt="Responsive image"
          />
        </b-col>
      </b-row>
    </b-modal>

    <AddGajiKaryawanContent
      v-model="addGajiKaryawanSidebar"
      :gaji-karyawan="dataEditGajiKaryawan"
      @gaji-karyawan-sidebar-change="bayarGajiKaryawan"
      @submit-data-gaji-karyawan="submitData"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BPagination, BTooltip, BButtonGroup, BImg, BBadge, BModal,
  VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import AddGajiKaryawanContent from './Add.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BTooltip,
    BButtonGroup,
    BImg,
    BBadge,
    BModal,

    AddGajiKaryawanContent,
    vSelect,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  data() {
    return {
      pageLength: 3,
      dir: false,
      columns: [
        {
          label: 'ID',
          key: 'id',
          sortable: true,
        },
        {
          label: 'Nama Karyawan',
          key: 'karyawan.nama',
        },
        {
          label: 'Nama Gaji',
          key: 'nama_gaji',
        },
        {
          label: 'Jumlah',
          key: 'nominal_gaji',
        },
        {
          label: 'Status',
          key: 'status',
        },
        {
          label: 'Action',
          key: 'action',
        },
      ],
      columnsLunas: [
        {
          label: 'No.',
          key: 'id',
          sortable: true,
        },
        {
          label: 'Nama Karyawan',
          key: 'karyawan.nama',
        },
        {
          label: 'Nama Gaji',
          key: 'nama_gaji',
        },
        {
          label: 'Jumlah',
          key: 'nominal_gaji',
        },
        {
          label: 'Status',
          key: 'status',
        },
        {
          label: 'Actions',
          key: 'action',
        },
      ],
      perPage: 5,
      totalGajiKaryawan: 0,
      totalGajiKaryawanLunas: 0,
      currentPage: 1,
      currentPageLunas: 1,
      perPageOptions: [5, 10, 25, 50],
      searchQuery: '',
      searchQueryLunas: '',
      sortBy: 'id',
      isSortDirDesc: true,
      statusFilter: null,
      rowsData: [],
      rowsDataLunas: [],
      searchTerm: '',
      statusOptions: [
        'Aktif',
        'Tidak Aktif',
      ],
      modalDetail: false,
      addGajiKaryawanSidebar: false,
      dataEditGajiKaryawan: {
        id: '1',
        nama: null,
        nama_gaji: null,
        jumlah: null,
        tanggal: null,
      },
      dataDetailGajiKaryawan: {
        id: '1',
        nama: null,
        nama_gaji: null,
        jumlah: null,
        tanggal: null,
        karyawan: {
          nama: '',
          posisi: '',
        },
        keuangan: {
          tanggal: '',
        },
      },
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    rows() {
      return this.rowsData
    },
    rowsLunas() {
      return this.rowsDataLunas
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      // eslint-disable-next-line no-return-assign
      this.$http.get('/gaji-karyawan').then(response => {
        this.rowsData = response.data.data

        this.totalGajiKaryawan = response.data.data.length
      })
      this.$http.get('/pembayaran-gaji').then(response => {
        this.rowsDataLunas = response.data.data

        this.totalGajiKaryawanLunas = response.data.data.length
      })
    },
    bayarGajiKaryawan(data, value) {
      this.dataEditGajiKaryawan = data
      this.addGajiKaryawanSidebar = value
    },
    detailGajiKaryawan(data) {
      this.dataDetailGajiKaryawan = data
      this.modalDetail = true
    },
    submitData(data) {
      if (data.id === null) {
        const formData = new FormData()
        formData.append('nama', data.nama)
        formData.append('telp', data.no_telp)
        formData.append('status', data.status)

        this.$http.post('/GajiKaryawan-add', formData).then(response => {
          this.getData()

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Notification',
              icon: 'BellIcon',
              text: response.data.message,
              variant: 'success',
            },
          })
        })
      } else {
        const formData = new FormData()
        formData.append('foto_nota', data.foto_nota)

        this.$http.post(`/pembayaran-gaji/${data.id}`, formData).then(response => {
          this.getData()

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Notification',
              icon: 'BellIcon',
              text: response.data.message,
              variant: 'success',
            },
          })
        })
      }
      this.addGajiKaryawanSidebar = false
    },
    removeData(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.rowsData = this.rowsData.filter(item => item.id !== id)
          this.$swal({
            icon: 'success',
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
